import { Alert, Anchor, Center, Loader, Stack } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { authApi } from '../api/auth';
import { errorMessage } from '../api/client';
import { AuthCard } from '../components/AuthCard';
import { ru } from '../i18n/ru';
import { accentText } from '../theme';

type State =
  | { kind: 'checking' }
  | { kind: 'ok'; message: string }
  | { kind: 'failed'; message: string };

export function ConfirmEmailPage() {
  const [searchParams] = useSearchParams();

  const userId = searchParams.get('userId');
  const token = searchParams.get('token');
  const linkIsComplete = userId !== null && token !== null;

  // Неполную ссылку видно уже при рендере — эффект для этого не нужен.
  const [state, setState] = useState<State>(() =>
    linkIsComplete ? { kind: 'checking' } : { kind: 'failed', message: ru.auth.confirmBadLink },
  );

  // В StrictMode эффекты выполняются дважды; повторный запрос подтверждения
  // не сломает результат, но и смысла в нём нет.
  const requested = useRef(false);

  useEffect(() => {
    if (requested.current || !linkIsComplete) {
      return;
    }
    requested.current = true;

    authApi
      .confirmEmail(userId, token)
      .then((result) => setState({ kind: 'ok', message: result.message }))
      .catch((error: unknown) =>
        setState({ kind: 'failed', message: errorMessage(error, ru.auth.confirmBadLink) }),
      );
  }, [userId, token, linkIsComplete]);

  return (
    <AuthCard title={ru.auth.confirmTitle} width={480}>
      <Stack gap="md">
        {state.kind === 'checking' && (
          <Center h={80}>
            <Loader color={accentText} />
          </Center>
        )}

        {state.kind === 'ok' && (
          <Alert color="green" title={ru.common.success}>
            {state.message}
          </Alert>
        )}

        {state.kind === 'failed' && (
          <Alert color="red" title={ru.common.error}>
            {state.message}
          </Alert>
        )}

        {state.kind !== 'checking' && (
          <Anchor component={Link} to="/login" size="sm" c={accentText}>
            {ru.auth.goToLogin}
          </Anchor>
        )}
      </Stack>
    </AuthCard>
  );
}
